import { FC } from 'react';

type Props = {
  message: string;
  onRetry: () => void;
};

export const LoadError: FC<Props> = ({ message, onRetry }) => (
  <div className="content-full-width">
    <span className="oath-bodysmall">
      {message}{' '}
      <button type="button" className="link-text inkBlue padding0" onClick={onRetry}>
        Retry
      </button>
    </span>
  </div>
);
